import { useLayoutEffect } from 'react';

import { useSectors } from '../../context/sectors';
import { SectorDataInstance } from './SectorDataProvider.class';

export const useBlockSectorDataProvider = () => {
  const { setSelectedSectors } = useSectors();

  useLayoutEffect(() => {
    SectorDataInstance.blockSectors();

    return () => {
      SectorDataInstance.unblockSectors();
    };
  }, [setSelectedSectors]);
};
